import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import IcRoundLock from '~icons/ic/round-lock'

export const SecurePaymentNote: FC = () => {
  const { t } = useTranslation(['membership'])
  return (
    <div className="pt-2 space-y-2">
      <div className="flex items-center gap-2">
        <IcRoundLock className="size-4 shrink-0 text-primary/60" />
        <p className="text-sm font-medium leading-tight text-primary/70">
          {t('membership:plans-page.promotion.secure-payments.title')}
        </p>
      </div>
      <p className="text-xs leading-snug text-primary/50">
        {t('membership:plans-page.promotion.secure-payments.description')}
      </p>
    </div>
  )
}
